import {Component, Input, OnInit, Optional, Inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {SnackbarService} from '@app/core/services/snackbar.service';
import {RefreshListener} from '@app/shared/models/refresh-listener';
import {OverlayService} from '@app/shared/components/overlay/overlay.service';
import {finalize} from 'rxjs/operators';
import {TimeOffService} from '@app/modules/time-off/services/time-off.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'add-time-off',
    templateUrl: './add-time-off.component.html',
    styleUrls: ['./add-time-off.component.scss']
})
export class AddTimeOffComponent implements OnInit {

    @Input() refreshListener: RefreshListener;

    public formId: string = 'frm_Wv4eJ3x3xPuSRy';
    public formData: any;
    public getFormData: boolean = false;
    public formValid: boolean = false;
    public formPristine: boolean;
    public filePath: SafeUrl;

    constructor(
        private fb: UntypedFormBuilder,
        private timeOffService: TimeOffService,
        private snackbarService: SnackbarService,
        private overlayService: OverlayService,
        private sanitizer: DomSanitizer,
        @Optional() private dialogRef: MatDialogRef<AddTimeOffComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) private dialogData?: { refreshListener?: RefreshListener }
    ) {
        this.refreshListener = this.dialogData?.refreshListener ?? this.refreshListener;
    }

    ngOnInit(): void {
        this.createForm();
    }

    private createForm() {
        this.formData = {
            id: null,
            name: '',
            disabled: false,
            allowSelectionWithNoPolicy: false
        };
    }

    formDataEmitted(formData) {
        this.saveForm(formData);
    }

    formPristineEmitted(formPristine: boolean) {
        this.formPristine = formPristine;
    }

    formStatusUpdated(formValid: boolean) {
        this.formValid = formValid;
    }

    saveForm(formData: any) {
        this.overlayService.show();

        this.timeOffService.postTimeOffType({
            name: formData?.name,
            disabled: formData?.disabled ?? false,
            allowSelectionWithNoPolicy: formData?.allowSelectionWithNoPolicy ?? false
        })
            .pipe(
                finalize(() => this.overlayService.hide())
            )
            .subscribe((res) => {
                const createdTypeId = res?.timeOffTypeId ?? res?.id;
                const iconFile = (this as any).iconFile ?? null;

                if (iconFile) {
                    this.timeOffService.postTimeOffTypeIcon(iconFile, createdTypeId)
                        .subscribe(
                            () => this.handleSuccess(createdTypeId),
                            err => this.handleError(err)
                        );
                } else {
                    this.handleSuccess(createdTypeId);
                }
            }, err => {
                this.handleError(err);
            });
    }

    handleSuccess(createdTypeId?: string) {
        this.snackbarService.openSnackBar('Time Off Type Saved', 'clear', 'success');

        if (this.dialogRef) {
            this.dialogRef.close(createdTypeId);
            return;
        }

        if (createdTypeId && this.refreshListener?.openTypeForEdit) {
            this.refreshListener.openTypeForEdit(createdTypeId);
            return;
        }

        this.refreshListener?.refresh?.();
    }

    handleError(err) {
        console.log(err);
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
    }

    cancel() {
        if (this.dialogRef) {
            this.dialogRef.close();
            return;
        }

        this.refreshListener?.cancel?.();
    }

    imagePreview(e) {
        const file = (e.target as HTMLInputElement).files[0];

        if (!file) {
            return;
        }

        (this as any).iconFile = file;

        const reader = new FileReader();
        reader.onload = () => {
            const value = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
            this.filePath = value;
        };
        reader.readAsDataURL(file);
    }
}
